import 'select2/dist/js/select2.min.js';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';

function formatState(state) {
    if (!state.id) {
        return state.text;
    }

    return $('<label class="select2-menu-item"><input type="checkbox"' + (state.selected ? ' checked' : '') + '> ' + state.text + '</label>');
}

var ajax_type_filter_form_partners = $('.ajax-type-filter-form-partners');
if (ajax_type_filter_form_partners.length > 0) {
    let Utils = $.fn.select2.amd.require('select2/utils'),
        Dropdown = $.fn.select2.amd.require('select2/dropdown'),
        DropdownSearch = $.fn.select2.amd.require('select2/dropdown/search'),
        AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody'),
        dropdownAdapter = Utils.Decorate(Utils.Decorate(Dropdown, DropdownSearch), AttachBody),
        queryString = window.location.search,
        urlParams = new URLSearchParams(queryString);

    $('.ajax-type-filter-form-partners select').each(function () {
        let select = $(this),
            select_name = select.attr('name'),
            getVal = urlParams.get(select_name);

        if (getVal != null) {
            if ($(this).closest('.ajax-type-filter-form-wrapper-partner_case').length) {
                let filters_data = window['binah_data_filter_partners'],
                    vals = getVal.split(','),
                    industry_active_keys = [];
                if (filters_data['industry']) {
                    for (const key in filters_data['industry']) {
                        let keys = Object.keys(filters_data['industry'][key]);
                        if (keys.some(r => vals.indexOf(r) >= 0)) {
                            industry_active_keys.push(key);
                        }
                    }
                }

                if (industry_active_keys.length) {
                    industry_active_keys.forEach(function (element) {
                        ajax_type_filter_form_partners.find('select option[value="' + element + '"]').prop('selected', true);
                    });

                    $('.ajax-type-filter-form-wrapper-partner_case select').html('');
                    industry_active_keys.forEach(function (item) {
                        if (filters_data['industry'][item]) {
                            for (const key in filters_data['industry'][item]) {
                                let newOption = new Option(filters_data['industry'][item][key], key, false, false);
                                $('.ajax-type-filter-form-wrapper-partner_case select').append(newOption);
                            }
                        }
                    })
                    $('.ajax-type-filter-form-wrapper-partner_case select').trigger('change');

                    vals.forEach(function (element) {
                        ajax_type_filter_form_partners.find('select option[value="' + element + '"]').prop('selected', true);
                    });
                }
            } else {
                if (ajax_type_filter_form_partners.hasClass('multiple')) {
                    var vals = getVal.split(',');
                    vals.forEach(function (element) {
                        ajax_type_filter_form_partners.find('select option[value="' + element + '"]').prop('selected', true);
                    });
                } else {
                    select.val(getVal);
                }
            }
        }
    });

    $.fn.select2.amd.define('CustomSelectionAdapter', [
        'select2/utils',
        'select2/selection/multiple',
        'select2/selection/placeholder',
        'select2/selection/eventRelay',
    ],
        function (Utils, MultipleSelection, Placeholder, EventRelay) {
            let adapter = Utils.Decorate(MultipleSelection, Placeholder);

            adapter = Utils.Decorate(adapter, EventRelay);

            adapter.prototype.render = function () {
                let $selection = MultipleSelection.prototype.render.call(this);
                $selection.html('<span class="multi-select-button"></span>');

                return $selection;
            };

            adapter.prototype.update = function (data) {
                this.clear();

                let $rendered = this.$selection.find('.multi-select-button'),
                    selected_text = '';

                if (data.length === 0) {
                    selected_text = this.options.get('placeholder').text || '';
                } else {
                    let selectedItems = [];

                    data.forEach(function (item) {
                        selectedItems.push(item.text);
                    })

                    selected_text = selectedItems.join();
                }

                $rendered.text(selected_text);
            };

            return adapter;
        });

    let selectionAdapter = $.fn.select2.amd.require('CustomSelectionAdapter');

    // location filter
    $('.ajax-type-filter-form-wrapper-partner_location select').select2({
        placeholder: {
            text: $('.ajax-type-filter-form-wrapper-partner_location select').data('default-label'),
        },
        closeOnSelect: false,
        templateResult: formatState,
        dropdownAdapter: dropdownAdapter,
        selectionAdapter: selectionAdapter,
    }).on('select2:opening select2:closing', function () {
        var $searchfield = $(this).parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
    }).on('select2:selecting', function (e) {
        let current_value = e.params.args.data.id;
        if ('-' == current_value) {
            e.preventDefault();

            $.magnificPopup.open({
                items: {
                    src: '#cantFindPartnerModal',
                    type: 'inline',
                },
            });
        }
    });

    //industry filter
    $('.ajax-type-filter-form-wrapper-partner_industry select').select2({
        placeholder: {
            text: $('.ajax-type-filter-form-wrapper-partner_industry select').data('default-label'),
        },
        closeOnSelect: false,
        templateResult: formatState,
        selectionAdapter: selectionAdapter,
    }).on('select2:opening select2:closing', function () {
        var $searchfield = $(this).parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
    });

    $('.ajax-type-filter-form-wrapper-partner_industry select').on('change', function () {
        let values = $(this).val(),
            filters_data = window['binah_data_filter_partners'];

        $('.ajax-type-filter-form-wrapper-partner_case select').html('');
        if (values.length) {
            values.forEach(function (item) {
                if (filters_data['industry'][item]) {
                    for (const key in filters_data['industry'][item]) {
                        let newOption = new Option(filters_data['industry'][item][key], key, false, false);
                        $('.ajax-type-filter-form-wrapper-partner_case select').append(newOption);
                    }
                }
            })
        }
        $('.ajax-type-filter-form-wrapper-partner_case select').trigger('change');
    });

    //case filter
    $('.ajax-type-filter-form-wrapper-partner_case select').select2({
        placeholder: {
            text: $('.ajax-type-filter-form-wrapper-partner_case select').data('default-label'),
        },
        closeOnSelect: false,
        templateResult: formatState,
        selectionAdapter: selectionAdapter,
    }).on('select2:opening select2:closing', function () {
        var $searchfield = $(this).parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
    });

    //reset button
    $('.btn-reset-filters').on('click', function () {
        $('.ajax-type-filter-form-wrapper-partner_location select').val(null).trigger('change');
        $('.ajax-type-filter-form-wrapper-partner_location select').data('select2').dataAdapter.destroy();
        $('.ajax-type-filter-form-wrapper-partner_industry select').val(null).trigger('change');
        $('.ajax-type-filter-form-wrapper-partner_industry select').data('select2').dataAdapter.destroy();
        $('.ajax-type-filter-form-wrapper-partner_case select').val(null).trigger('change');
        $('.ajax-type-filter-form-wrapper-partner_case select').data('select2').dataAdapter.destroy();
    });

    $(document).on('click', '.select2-results__option', function () {
        if ($(this).hasClass('select2-results__option--selected')) {
            $(this).find('input').prop('checked', true);
        } else {
            $(this).find('input').prop('checked', false);
        }
    });

    //update posts
    $(document).on('change', '.ajax-type-filter-form-partners select', function () {
        var tax_query = {};
        var i = 0;
        var post_type = $(this).attr('data-post-type');
        var flag_use_partner_industry = false;

        $('.ajax-type-filter-form-partners select').each(function () {
            var val = $(this).val() || 'all';
            var name = $(this).attr('name');
            var taxonomy = $(this).attr('data-taxonomy');

            tax_query[i] = {
                taxonomy: taxonomy,
                value: val,
            };

            if (Array.isArray(val) && !val.length) {
                val = 'all';
            }

            // Update URL with param
            var uri = window.location.href;
            var re = new RegExp('([?&])' + name + '=.*?(&|$)', 'i');
            var separator = uri.indexOf('?') !== -1 ? '&' : '?';
            if (uri.match(re)) {
                if (!('partner_industry' == name && 'all' == val && flag_use_partner_industry)) {
                    window.history.pushState({ path: uri.replace(re, '$1' + name + '=' + val + '$2') }, '', uri.replace(re, '$1' + name + '=' + val + '$2'));
                }
            }
            else {
                window.history.pushState({ path: uri + separator + name + '=' + val }, '', uri + separator + name + '=' + val);
            }

            if ('partner_industry' == name) {
                flag_use_partner_industry = true;
            }

            i++;
        });

        var data = window['binah_data_' + post_type];

        if (window.xhr) {
            window.xhr.abort();
        }

        window.xhr = $.post(
            data.ajaxurl, {
            action: 'ajax_filter_type',
            post_type: post_type,
            tax_query: JSON.stringify(tax_query),

            query: data.posts,
            page: 0,
            item_template: data.item_template,
            async: false,
        },
            function (res) {
                var parsed = $.parseJSON(res);

                window['binah_data_' + post_type].posts = parsed.query;
                window['binah_data_' + post_type].current_page = 1;
                window['binah_data_' + post_type].max_page = parsed.max_page;

                if (parsed['data']) {
                    $('.posts-listing').html(parsed['data']);
                    $('.alert-warning').hide();
                } else {
                    $('.posts-listing').html('');
                    $('.alert-warning').show();
                }

                $('.component-btn-load-more .btn-go-to-top').hide();
                $('.btn-load-more-posts').show().html('Load more');

                if (window.macyGrid) {
                    window.macyGrid.recalculate(true, true);

                    window.macyGrid.runOnImageLoad(function () {
                        window.macyGrid.recalculate(true);
                    }, true);
                }
            }
        );
    });

    $(document).on('click', '.component-list-item-partner__link', function (e) {
        e.preventDefault();

        let data = window['binah_data_partners'],
            post_id = $(this).data('partner_id');

        if (window.xhr) {
            window.xhr.abort();
        }

        $.magnificPopup.open({
            items: {
                src: '<article class="component-list-item-wrap-preload"><span class="loader"></span></article>',
                type: 'inline',
            },
            callbacks: {
                open: function() {
                    $('body').addClass('overflow-hidden');
                },
                close: function() {
                    $('body').removeClass('overflow-hidden');
                },
            },
            fixedContentPos: true,
        });

        window.xhr = $.post(
            data.ajaxurl, {
            action: 'ajax_get_partner_post',
            post_id: post_id,
            async: false,
        },
            function (res) {
                var parsed = $.parseJSON(res);

                if (parsed['data']) {
                    $.magnificPopup.open({
                        items: {
                            src: parsed['data'],
                            type: 'inline',
                        },
                        callbacks: {
                            open: function() {
                                $('body').addClass('overflow-hidden');
                            },
                            close: function() {
                                $('body').removeClass('overflow-hidden');
                            },
                        },
                    });
                }
            }
        );
    });

    $(document).on('click', '.mfp-close-btn', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
}


// WEBPACK FOOTER //
// ./scripts/components/ajax-type-filter-partners.js